var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrullenbak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.29,
    height: 19.065,
    viewBox: "0 0 17.29 19.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Prullenbak",
    transform: "translate(16325.754 23329.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.631,1.787H16.56A69.859,69.859,0,0,0,2.548,1.61L.739,1.787A.67.67,0,0,1,0,1.184.661.661,0,0,1,.6.457L2.406.28A71.959,71.959,0,0,1,16.693.457a.666.666,0,0,1,.594.727A.657.657,0,0,1,16.631,1.787Z",
    transform: "translate(-16325.754 -23326.678)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.666,3.964A.545.545,0,0,1,.55,3.955.668.668,0,0,1,.01,3.192L.2,2.031C.347,1.179.542,0,2.608,0H4.931c2.075,0,2.27,1.224,2.4,2.04l.2,1.153a.661.661,0,1,1-1.3.222l-.2-1.153c-.124-.772-.151-.922-1.091-.922H2.617c-.94,0-.958.124-1.091.913l-.2,1.153A.665.665,0,0,1,.666,3.964Z",
    transform: "translate(-16320.874 -23329.75)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.588,12.735H3.895C.8,12.735.676,11.024.578,9.64L0,.71A.671.671,0,0,1,.622,0a.672.672,0,0,1,.709.621l.576,8.93c.1,1.348.133,1.853,1.986,1.853H9.588c1.862,0,1.9-.505,1.986-1.853l.576-8.93A.678.678,0,0,1,12.86,0a.666.666,0,0,1,.621.709L12.9,9.64C12.807,11.024,12.683,12.735,9.588,12.735Z",
    transform: "translate(-16323.845 -23323.42)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.618,1.33H.665A.67.67,0,0,1,0,.665.67.67,0,0,1,.665,0H3.618a.67.67,0,0,1,.665.665A.67.67,0,0,1,3.618,1.33Z",
    transform: "translate(-16319.25 -23316.891)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5.1,1.33H.665A.67.67,0,0,1,0,.665.67.67,0,0,1,.665,0H5.1a.67.67,0,0,1,.665.665A.67.67,0,0,1,5.1,1.33Z",
    transform: "translate(-16319.986 -23320.439)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrullenbak);
export default __webpack_public_path__ + "static/media/Icon-Prullenbak.f5a17447c18f819fa17d76f0887cd25c.svg";
export { ForwardRef as ReactComponent };